export enum ComplianceRatingId {
  compliant = 'COMPLIANT',
  partlyCompliant = 'PARTLY_COMPLIANT',
  notCompliant = 'NOT_COMPLIANT',
  notRated = 'NOT_RATED'
}
